import { useEffect, useState } from 'react';
import { Divider, Space, Table, Select, Input, Button } from 'antd';
import { formatNumber, exportToCSV } from '../../utils/functions';
import DateSelector from '../../components/DateSelector';
import useWebPost from '../../utils/useWebPost';
import FullHeightLayout from '../../components/FullHeightLayout';

const { Option } = Select;
function Tjxxp({ dataSource = [], searchKeys = {} }) {
    const [filters, setFilters] = useState({});
    const [data, setData] = useState([]);
    const [dates, setDates] = useState(null);
    const webPost = useWebPost();
    const [sumItem, setSumItem] = useState({});
    const fetchItem = async () => {
        const params = { ...filters, ...searchKeys, ...dates };
        const res = await webPost("tjXxpList", params);
        if (res) {
            setData(res.map(item => ({ ...item, fp_type: Number(item.fp_type) === 1 ? '电子专票' : '电子普票' })));
        }
    }
    useEffect(() => {
        let sum1 = 0, sum2 = 0, sum3 = 0;
        data.map(it => {
            sum1 += Number(it.bhsje) || 0;
            sum2 += Number(it.amount_sj) || 0;
            sum3 += Number(it.amount) || 0;
        })
        setSumItem({ sum1: sum1.toFixed(2), sum2: sum2.toFixed(2), sum3: sum3.toFixed(2) });
    }, [data]);


    const columns = [
        {
            title: '序号',
            dataIndex: 'serialNumber',
            width: 58,
            render: (text, record, rowIndex) => {
                return rowIndex + 1;
            },
        },
        {
            title: '项目',
            dataIndex: 'xmmc',
            width: 160,
        },
        {
            title: '时间',
            dataIndex: 'make_date2',
            width: 120,
        },
        {
            title: '买方单位',
            dataIndex: 'mf_dw',
            width: 140,
        },
        {
            title: '发票种类',
            dataIndex: 'fp_type',
            width: 80,
        },
        {
            title: '税率(%)',
            dataIndex: 'kpsl',
            width: 90,
        },
        {
            title: '含税金额',
            width: 160,
            dataIndex: 'amount',
        },
        {
            title: '应收税款',
            width: 140,
            dataIndex: 'amount_sj',
        },
        {
            title: '预缴合计',
            width: 140,
            dataIndex: 'sum_se',
        },
        {
            title: '发票号',
            width: 140,
            dataIndex: 'invoice_no',
        },
        {
            title: '备注1',
            width: 140,
            dataIndex: 'remark1',
        },
        {
            title: '备注2',
            width: 140,
            dataIndex: 'remark2',
        }

    ];
    return (
        <FullHeightLayout
            headerContent={
                <div style={{ position: 'relative', paddingBottom: 10, paddingRight:120 }}>
                    {/* 第一行 */}
                    <Space size='middle' style={{ marginTop: 8, marginRight:16 }} wrap>
                        <DateSelector onChange={(v) => { setDates(v); }} />
                    </Space>

                    {/* 第二行 ↓ 这里自动换行了 */}
                    <Space size='middle' style={{ marginTop: 8, marginRight:16 }} wrap>
                        <Select placeholder='类型' style={{ width: '120px' }} onChange={(v) => setFilters(prev => ({ ...prev, "lx": v }))}>
                            <Option value='1'>项目名称</Option>
                            <Option value='2'>项目编号</Option>
                            <Option value='3'>制单人</Option>
                            <Option value='4'>开票税率</Option>
                            <Option value='5'>金额</Option>
                        </Select>
                        <Input onChange={(e) => setFilters(prev => ({ ...prev, 'key': e.target.value }))} />
                    </Space>
                    <Space size='middle' style={{ marginTop: 8, marginRight:16 }} wrap>
                        <Input placeholder='填报企业' onChange={(e) => setFilters(prev => ({ ...prev, 'key2': e.target.value }))} />
                    </Space>
                    <Space size='middle' style={{ marginTop: 8, marginRight:16 }} wrap>
                        <Input placeholder='开票税率' onChange={(e) => setFilters(prev => ({ ...prev, 'key3': e.target.value }))} />
                    </Space>
                    <Space size='middle' style={{ marginTop: 8, marginRight:16 }} wrap>
                        <Button type="primary" onClick={fetchItem} >搜索</Button>
                    </Space>

                    {/* 下载按钮（绝对定位不干扰布局） */}
                    <Button
                        type="dashed"
                        onClick={() => exportToCSV(data, columns.slice(1), '销项票统计')}
                        style={{
                            position: 'absolute',
                            right: 10,
                            top: 10,
                            zIndex: 10
                        }}
                    >
                        下载本页数据
                    </Button>
                </div>
            }
            footerContent={
                <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    不含税金额总计：{sumItem?.sum1}; 税金总计：{sumItem?.sum2}；开票总计: {sumItem?.sum3}
                </div>
            }
        >
            <Table
                dataSource={data}
                columns={columns}
                rowKey='id'
                pagination={false}
                style={{ minWidth: '100%', marginBottom: 16 }}
                scroll={{
                    x: 1800,
                    y: "calc(100vh - 240px)"
                }}
                tableLayout="fixed"
            />
        </FullHeightLayout>

    );
}

export default Tjxxp;
